import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useFormikContext } from 'formik';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    padding: theme.spacing(1, 3),
    paddingRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  headerError: {
    backgroundColor: theme.palette.error.background,
  },
  title: {
    flex: 1,
  },
  content: {},
  spacingTop: {
    marginTop: theme.spacing(2),
  },
  spacingBottom: {
    marginBottom: theme.spacing(2),
  },
}));


export type PsychiatryNotesSectionProps = {
  title?: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
  isError?: boolean;
  spacingTop?: boolean;
  spacingBottom?: boolean;
};


export const PsychiatryNoteSection: React.FC<PsychiatryNotesSectionProps> = ({
  spacingTop = true,
  spacingBottom = true,
  ...props
}) => {
  const formik = useFormikContext();
  const { classes, cx } = useStyles();
  const isError = props.isError ?? formik?.isValid === false;

  return (
    <Box className={classes.root}>
      {(props.title || props.subtitle || props.actions) && (
        <Box className={cx(classes.header, { [classes.headerError]: isError })}>
          <Box className={classes.title}>
            <Typography component="strong" fontWeight={500}>
              {props.title}
            </Typography> {props.subtitle && (
              <Typography component="i">
                {props.subtitle}
              </Typography>
            )}
          </Box>

          {props.actions}
        </Box>
      )}
      <Divider />
      <Box
        className={cx(classes.content, {
          [classes.spacingTop]: spacingTop,
          [classes.spacingBottom]: spacingBottom
        })}
      >
        {props.children}
      </Box>
    </Box>
  );
};
